import React from 'react';
import styles from './css/timeline.module.css';
import { useSelector } from 'react-redux';
export default function timeline(TimelineProps) {
    var timeLineStep = useSelector(function (state) { return state.app.timeLineStep; });
    return (React.createElement("section", { className: styles.timeline },
        React.createElement("ol", null,
            React.createElement("li", { className: styles.welcomeIcon + " " + (timeLineStep >= 1 ? styles.active : '') }, "Welcome"),
            React.createElement("li", { className: styles.locationIcon + " " + (timeLineStep >= 2 ? styles.active : '') }, "Location"),
            React.createElement("li", { className: styles.mountIcon + " " + (timeLineStep >= 3 ? styles.active : '') }, "Mount"),
            React.createElement("li", { className: styles.scheduleIcon + " " + (timeLineStep >= 4 ? styles.active : '') }, "Schedule"),
            React.createElement("li", { className: styles.contactIcon + " " + (timeLineStep >= 5 ? styles.active : '') }, "Contact"),
            React.createElement("li", { className: styles.confirmationIcon + " " + (timeLineStep === 6 ? styles.active : '') }, "Confirmation"))));
}
